import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { Chip } from '@mui/material';

interface BkErrorChipProps {
  label: string;
}

export const BkErrorChip: React.FC<BkErrorChipProps> = ({ label }) => {
  return (
    <Chip
      sx={{
        background: '#FFF',
        border: '0.0625rem solid #B3261E',
        fontWeight: '600',
        borderRadius: '0.75rem',
        color: '#B3261E',
        '& .MuiSvgIcon-root': {
          color: '#B3261E',
        },
      }}
      icon={<InfoIcon />}
      label={label}
    />
  );
};
